import { DAYS_TO_MS } from '@utils/constants';
import { getAuthorizedProductsForUser } from './api.get-authorized-products-for-user.js';
import { getPortalList } from './api.get-list.js';

const getPortalsForUserQuery = user => {
  return {
    queryKey: ["user-area/get-portals-for-user", user?.id],
    queryFn: () => getPortalsForUser(user),
    staleTime: 1 * DAYS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  };
};

/**
 * Returns all models that a user is authorized to access.
 */
async function getPortalsForUser(user) {
  if (!user) {
    return [];
  }
  const [portals, authorizedProductsSet] = await Promise.all([await getPortalList(), await getAuthorizedProductsForUser(user)]);
  return (portals ?? []).filter(it => authorizedProductsSet.has(it.licenseKey));
}

export { getPortalsForUser, getPortalsForUserQuery };
//# sourceMappingURL=api.get-for-user.js.map
